import React from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";

const tabs = [
  { label: "All Jobs", to: "/jobs" },
  { label: "Saved Jobs", to: "/jobs/saved" },
  { label: "Applied Jobs", to: "/jobs/applied" },
  { label: "Recommended For You", to: "/jobs/recommended" },
];

export default function JobsLayout() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="max-w-6xl mx-auto px-4 py-10 sm:px-6">
        {/* Page Header */}
        <header className="mb-6">
          <h1 className="text-3xl font-bold text-slate-900">
            Find the Right Job for You
          </h1>
          <p className="mt-2 text-slate-600">
            AI-powered UK job search with employer details and saved application tracking.
          </p>
        </header>

        {/* 🔔 Demo Warning Banner */}
        <div className="mb-6 p-4 rounded-2xl border border-amber-200 bg-amber-50 text-amber-900 text-sm">
          <span className="font-semibold">⚠ Demo Mode:</span>{" "}
          The jobs shown here are sample listings for platform demonstration
          purposes. Real-time job integrations and live employer listings are
          coming soon.
        </div>

        {/* Tabs */}
        <div className="border-b border-slate-200 mb-6">
          <nav className="-mb-px flex gap-4 overflow-x-auto scrollbar-hide" aria-label="Jobs sections">
            {tabs.map((tab) => {
              const isActive =
                tab.to === "/jobs"
                  ? location.pathname === "/jobs"
                  : location.pathname.startsWith(tab.to);

              return (
                <NavLink
                  key={tab.to}
                  to={tab.to}
                  className={
                    "whitespace-nowrap pb-2 px-1 text-sm font-medium border-b-2 transition " +
                    (isActive
                      ? "border-indigo-600 text-indigo-600"
                      : "border-transparent text-slate-500 hover:text-slate-800 hover:border-slate-300")
                  }
                  end={tab.to === "/jobs"}
                >
                  {tab.label}
                </NavLink>
              );
            })}
          </nav>
        </div>

        {/* Content (Subroute will render here) */}
        <div className="bg-white rounded-3xl shadow-[0_12px_40px_rgba(15,23,42,0.06)] border border-slate-200 p-4 md:p-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
